import { Select,Form} from 'antd'
import React, { useEffect, useState } from 'react'
import { useBnsXiangMuXuQiuListQuery } from '../../store/BnsKeJiApi';
function ModuleSelect(props) {    
    const {data,isSuccess} = useBnsXiangMuXuQiuListQuery({bxmxq_bxm_id:props.bxm_id,bxmxq_yh_id:props.yh_id},{refetchOnMountOrArgChange:1})    
    const [list, setList] = useState();
    useEffect(() => {
        if(isSuccess){            
            if(data.Status==='success'){
                const newArr = data.Result.map(item => {
                    const {bxmxq_id:key,bxmxq_name,} = item;
                    return item = {value:key,label:bxmxq_name,}
                })                
                let sorrArr = newArr.sort((a, b) => {
                    // 提取bxmbb_name的第一个数字
                    const getFirstNumber = (name) => {
                        if (!name) return 0;
                        const match = name.match(/\d+/);
                        return match ? parseInt(match[0]) : 0;
                    };
                    
                    const numA = getFirstNumber(a.bxmbb_name);
                    const numB = getFirstNumber(b.bxmbb_name);
                    
                    return numA - numB;
                });
                setList(sorrArr)
            }else{
                setList('')
            }
            
        }
    }, [data, isSuccess])   
    return (
        <>
            <Form.Item 
                label={props.label} 
                wrapperCol={props.wrapperCol} 
                required={props.required}
                name={props.name}
                style={props.FormStyle}
            >
                <Select 
                    options={list} 
                    onChange={(_,f) => {
                        props.onChange(f.value,f.label,f.ed_id,f.ed_name)
                    }}
                    defaultValue={props.defaultId}
                    placeholder={props.defaultId}
                    style={props.style}
                />
            </Form.Item>
        </>
    )
}

export default ModuleSelect
